<template>
  <!-- <div class="header" :style="{padding: `0px ${padding}px`}"> -->
  <div class="header">
    <div class="content">
      <div class="left-box" @click="checkLogin()" style="cursor: pointer">
        <img src="@/assets/images/web-logo.png" alt="" />
        <div class="text">
          <span class="main-title">皂富鹅</span>
          <span class="sub-title">独树一帜 只为梦想</span>
        </div>
      </div>
      <div class="right-box">
        <!-- <router-link class="menu" to="">首页</router-link> -->
        <router-link class="menu" to="">
          <el-popover placement="bottom" trigger="click">
            <div class="ewm">
              <p>微信扫码进入皂富鹅</p>
              <img src="@/assets/images/ewm.png" alt="" />
            </div>
            <div slot="reference">小程序</div>
          </el-popover>
        </router-link>
        <router-link class="menu set" to="" v-if="userinfo">
          <el-dropdown trigger="click">
            <span class="el-dropdown-link"> 设置 </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                ><div @click="toSet()">个人设置</div></el-dropdown-item
              >
              <el-dropdown-item
                ><div @click="toLogin">退出登录</div></el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </router-link>
        <div
          v-if="currentPath.indexOf('/home') >= 0 && isLogin"
          class="menu"
          @click="toLogin"
        >
          退出
        </div>
      </div>
    </div>
    <!-- <el-dialog :visible.sync="dialogVisible2" class="dialog2">
      <template #title>
        <div class="confirm">退出登录</div>
        <el-button
          size="mini"
          type="text"
          style="float: right; padding: 0"
          @click="dialogVisible2 = false"
        >
          <img
            src="@/assets/images/discussion/Group 69.png"
            style="position: absolute; right: 15px; top: 15px"
            alt=""
          />
        </el-button>
      </template>
      <span class="isDelete">确认是否退出登录？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false" class="leftBtn"
          >取 消</el-button
        >
        <el-button type="primary" @click="submit" class="rightBtn"
          >确 定</el-button
        >
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import { LOGIN_TOKEN_KEY, LOGIN_USER_INFO } from "@/utils/constants";
import { mapState } from "vuex";
import { getUserInfo } from "@/api/user";
export default {
  data() {
    return {
      padding: 0,
      dialogVisible2: false,
      userinfo: {},
      currentPath: "",
    };
  },
  computed: {
    ...mapState(["isLogin"]), // 映射 isLogin 到计算属性
  },
  watch: {
    $route(val) {
      this.currentPath = val.path;
    },
  },
  mounted() {
    this.currentPath = this.$route.path;
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    // this.getNewUserInfo();
    setTimeout(() => {
      let result = localStorage.getItem(LOGIN_USER_INFO);
      this.userinfo = JSON.parse(result);
      // console.log(" this.userinfo=====result", result);
      // console.log(" this.userinfo=====header", this.userinfo);
    }, 1000);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  created() {},
  methods: {
    // getNewUserInfo() {
    //   getUserInfo().then((res) => {
    //     this.userInfo = res.data;
    //     console.log("this.userInfo,this.userInfo", res.data);
    //   });
    // },
    checkLogin() {
      let result = localStorage.getItem(LOGIN_USER_INFO);
      this.userinfo = JSON.parse(result);
      console.log("11222", this.userinfo);
      if (this.userinfo) {
        this.$router.push("/in/clockin");
      } else {
        this.$router.push("/home");
      }
    },
    toLogin() {
      // console.log(11111111111111111111111);

      // this.dialogVisible2 = true;
      this.$message({
        message: "您已退出登录",
        type: "success",
      });
      // this.dialogVisible2 = false;
      console.log("退出登录");
      localStorage.removeItem(LOGIN_TOKEN_KEY);
      localStorage.removeItem(LOGIN_USER_INFO);
      this.$store.commit("clearUserInfo");

      this.$store.dispatch("logout");

      this.$router.push("/home");
    },
    toSet() {
      this.$router.push("/in/me/set");
    },
    // submit() {
    //   this.$message({
    //     message: "您已退出登录",
    //     type: "success",
    //   });
    //   this.dialogVisible2 = false;
    //   console.log("退出登录");
    //   localStorage.removeItem(LOGIN_TOKEN_KEY);
    //   localStorage.removeItem(LOGIN_USER_INFO);
    //   this.$router.push("/home");
    // },
    handleResize() {
      let w = document.documentElement.clientWidth;
      if (w < 1440) {
        w = 1440;
      }
      let offset = w - 1120;
      if (offset < 0) {
        offset = 0;
      }
      this.padding = offset / 2;
      // console.log('sss', w, offset);
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  // padding: 0px 160px;
  width: 100%;
  box-sizing: border-box;
  // left: 50%;
  // transform: translateX(-50%);
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0px;
  background: #fff;
  z-index: 99;

  .content {
    max-width: 1120px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 56px;
    margin: 0 auto;
    position: relative;
  }

  .left-box {
    display: flex;

    img {
      width: 36px;
      height: 36px;
      margin-right: 8px;
    }

    .text {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 36px;

      .main-title {
        font-weight: bold;
      }

      .sub-title {
        font-size: 12px;
      }
    }
  }

  .right-box {
    display: flex;
    position: relative;

    .menu {
      margin-left: 48px;
      font-weight: 500;
      font-size: 14px;
      color: #000000 !important;
      text-decoration: none;
      cursor: pointer;
    }

    .set {
    }
  }
}
.el-dropdown-link {
  cursor: pointer;
}

.el-dropdown {
  color: #000000 !important;
}

// .el-dropdown-menu {
//    top: 50px !important;
// }

.el-dropdown-menu__item {
  color: #000000 !important;
}

.dialog2 {
  ::v-deep .el-dialog {
    width: 352px;
    margin-top: 35vh !important;
  }

  ::v-deep .el-dialog__header {
    padding-bottom: 9px;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
  }

  ::v-deep .el-dialog__body {
    text-align: center;
    padding: 48px 0;
  }

  ::v-deep .el-button {
    width: 151px;
  }

  ::v-deep .el-icon-date:before {
    content: "";
  }

  ::v-deep .el-icon-close:before {
    content: "";
  }

  .confirm {
    width: 64px;
    height: 16px;
    font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .isDelete {
    width: 208px;
    height: 24px;
    font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .leftBtn {
    height: 48px;
    border-radius: 8px 8px 8px 8px;
    border: 0.5px solid rgba(0, 0, 0, 0.1);
    font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    line-height: 16px;
  }

  .rightBtn {
    height: 48px;
    background: #cf0f0f;
    border-radius: 8px 8px 8px 8px;
    border: 0.5px solid rgba(0, 0, 0, 0.1);
    font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    line-height: 16px;
  }
}

.v-modal {
  // display: none;
  z-index: 98 !important;
}
</style>
<style lang="scss" scoped>
.ewm {
  padding: 14px;

  text-align: center;

  img {
    margin-top: 16px;
    width: 100px;
  }
}
</style>
